import { gEnums } from 'global/enums/globalEnums'
import { useMatchSchedule } from 'projectSpecific/sports/useHelpers/useMatchSchedule'
import React, { useContext } from 'react'
import { MatchesSchedule } from './MatchesSchedule'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { SeasonMatchesContext } from 'projectSpecific/sports/cnr/contexts/SeasonMatchesContext'
import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions'

export const TeamSchedule = ({ matchDisplayType, matchScheduleDisplayType, teamKey }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {};
  const { paps_state, appUser_state } = states ?? {};
  const { pathViews } = paps_state ?? {};

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchFilter, _shows_matches, commonMatches } = seasonMatches_state ?? {}

  const { _matchDisplayType, _matchDisplayOptions } = useMatchScheduleOptions({ matchScheduleDisplayType })

  return <MatchesSchedule
    matchScheduleDisplayType={matchScheduleDisplayType}
    teamKey={teamKey || pathViews.teams}
    matchDisplayOptions={_matchDisplayOptions}
    matchFilter={matchFilter}
    matchDisplayType={_matchDisplayType}
  />

  return (
    <div>{`TeamSchedule-${matchDisplayType}-${matchScheduleDisplayType}`}</div>
  )
}
